var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableDeleteButton2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.352,
    height: 15.52,
    viewBox: "0 0 14.352 15.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke_1",
    "data-name": "Stroke 1",
    d: "M10.755,0s-.412,5.1-.65,7.254A1.7,1.7,0,0,1,8.317,8.9c-1.977.036-3.957.038-5.933,0A1.678,1.678,0,0,1,.649,7.26C.409,5.091,0,0,0,0",
    transform: "translate(1.799 5.842)",
    fill: "none",
    stroke: "#d43636",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_3",
    "data-name": "Stroke 3",
    d: "M12.852.5H0",
    transform: "translate(0.75 2.895)",
    fill: "none",
    stroke: "#d43636",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_5",
    "data-name": "Stroke 5",
    d: "M7.9,2.644a1.249,1.249,0,0,1-1.224-1L6.491.719A.97.97,0,0,0,5.554,0H2.346a.97.97,0,0,0-.937.719l-.184.922A1.249,1.249,0,0,1,0,2.644",
    transform: "translate(3.226 0.751)",
    fill: "none",
    stroke: "#d43636",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableDeleteButton2);
export default __webpack_public_path__ + "static/media/table-delete-button-2.27f9687cd9adbf08e920342f0c4042c5.svg";
export { ForwardRef as ReactComponent };